import React, {Component} from "react"
import {Entity} from 'aframe-react'

import SearchBox from './search-input'
import fixed from "../components-aframe/fixed"

import frameButton from "../components-aframe/frameButton"

import ImageGrid from "../components/ImageGrid"
import ImageGridEven from "../components/ImageGridEven"

import Quicksand from "../assets/fonts/quicksand.fnt"
import QuicksandSheet from "../assets/fonts/quicksand.png"

import devfest from "../assets/devfest/manifest"
import gridset from "../assets/devfest/grid"


class PopupDisplay extends Component {

    constructor(props) {
        super (props)
    }


    renderDefault() {

        return null;
    }

    renderSearchBox() {
        return (
            <SearchBox text={this.props.mic.text} />
        );
    }

    renderKeyInput() {
        return (
            <SearchBox text={this.props.keyboard.text} />
        );
    }

    renderSpinner() {
        return null;
    }

    itemClick(img) {
        var rotation = document.getElementById("camera").getAttribute("rotation")

        this.props.setWorldState("WORLD_VIEW");
        this.props.addBox(img, rotation.x, rotation.y);
    }

    renderSelectGrid () {
        console.log(this.props.search.results);

        return (
            <ImageGrid 
                items={this.props.search.results} 
                rotation={this.props.search.pos} 

                click={ (item) => {
                    this.itemClick(item)
                }}
            />
        );
    }

    renderImageGrid() {
        return (
            <ImageGridEven 
                items={devfest.icons}

                grid={gridset.grid}
                icon={gridset.icon}
                navigation={gridset.navigation}

                click={ (item) => {
                    this.itemClick(item)
                }}
            />
        )
    }

    renderError () {

        console.log("RENdering an error message");

        return (
            <Entity id="txt-err" position={{x: 0, y: 0, z: 0}} fixed>

                <Entity position={{x:0, y:0.1, z: -3}}>

                    <Entity
                        primitive="a-text"
                        value={"Result Not Found"}

                        color="#282828"

                        text={{
                            font: Quicksand,
                            fontImage: QuicksandSheet,
                        }}

                        align="center"
                    />

                </Entity>

            </Entity>
        )
    }

    render() {

        switch (this.props.globalState.worldView) {
            case "WORLD_VIEW":
                return this.renderDefault();

            case "WORLD_INPUT":
                return this.renderSearchBox();
            
            case "WORLD_KEYBOARD":
                return this.renderKeyInput();

            case "WORLD_SELECT":
                return this.renderSelectGrid();
            
            case "WORLD_ICON":
                return this.renderImageGrid();
            
            case "WORLD_ERROR":
                return this.renderError();

            default:
                return null
        }
    }
}

export default PopupDisplay;



// WEBPACK FOOTER //
// ./src/components/popup-display.js